
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Der Epidemieforscher Marc Lipsitch von der Harvard University `}<Link disco href='https://twitter.com/mlipsitch/status/1234879949946814464?s=20' mdxType="Link">{`sagt`}</Link>{`, 20 bis 60% der Menschen werden sich mit Sars-CoV-2 infizieren. Die meisten seiner Kollegen stimmen ihm zu, die WHO spricht von 40 bis 80%. Auch der deutsche Virologe Christian Drosten von der Berliner Charité erwartet hohe Infektionszahlen. «Es werden sich wahrscheinlich bis zu 70 Prozent infizieren, aber wir wissen nicht, in welcher Zeit», sagte er. «Das kann durchaus zwei Jahre dauern oder sogar noch länger.» Problematisch werde das Infektionsgeschehen nur, wenn es in komprimierter, kurzer Zeit auftrete. `}<strong parentName="p">{`Die meisten Epidemiologen gehen davon aus, dass das Virus langfristig bei uns bleiben wird.`}</strong>{` Sars-CoV-2 wird sich in der menschlichen Population etablieren und über die nächsten Jahre mit uns bleiben. Zum Vergleich: Mit der Grippe stecken sich gemäss WHO weltweit jährlich 5 bis 20% an. In der Schweiz 2 bis 5%.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;